import type { FieldError } from 'react-hook-form';

type Translator = (key: string, options?: Record<string, unknown>) => string;

export const resolveValidationMessage = (
  t: Translator,
  error?: FieldError,
  options?: Record<string, unknown>
): string | undefined => {
  const message = error?.message;
  if (!message) return undefined;

  const normalized = message.toLowerCase();
  if (
    normalized === 'required' ||
    normalized.includes('expected number, received null') ||
    normalized.includes('expected string, received null') ||
    normalized.includes('expected number, received nan') ||
    normalized.includes('expected string, received undefined') ||
    normalized.includes('expected number, received undefined') ||
    normalized.includes('expected date, received null') ||
    normalized.includes('expected date, received undefined')
  ) {
    return t('validation.required');
  }

  if (message.startsWith('validation.') || message.startsWith('form.')) {
    return t(message, options);
  }

  return message;
};
